export function waitDebounce(func, wait, immediate) {
    let timeout;
    let startTime = 0;

    return function() {
        let context = this, args = arguments;

        let later = function() {
            timeout = null;
            const endTime = new Date().getTime() - startTime;
            if (!immediate) func.apply(context, [...args, endTime]);
        };

        if (!timeout) {
            // only if no timeout exists.. this is a NEW event starting
            startTime = new Date().getTime();
        }

        let callNow = immediate && !timeout;
        clearTimeout(timeout);

        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, [...args, 0]);
    };
}